import * as C from 'actions/constants';
import { mergeCategoryData } from './categoryUtils';

export const blankState = {
  meta: {},
  reportsCount: 0,
  data: [],
  allData: [],
  loading: false,
};

const CategoryReducer = (state = blankState, action) => {
  switch (action.type) {
    case C.LOAD_CATEGORIES:
    case C.CREATE_CATEGORY:
    case C.EDIT_CATEGORY:
    case C.DELETE_CATEGORY: {
      return { ...state, loading: true };
    }
    case C.LOAD_CATEGORIES_SUCCESS: {
      const { data, meta } = action;
      return {
        ...state,
        loading: false,
        meta,
        data: mergeCategoryData(data, state.allData),
      };
    }
    case C.LOAD_ALL_CATEGORIES_SUCCESS: {
      const { data } = action;
      return {
        ...state,
        allData: data,
        data: mergeCategoryData(state.data, data),
      };
    }
    case C.SELECT_CATEGORY_SUCCESS: {
      const { data } = action;
      return {
        ...state, selected: data,
      };
    }
    case C.DELETE_CATEGORY_SUCCESS:
    case C.CREATE_CATEGORY_SUCCESS:
    case C.EDIT_CATEGORY_SUCCESS:
    case C.DELETE_CATEGORY_ERROR:
    case C.EDIT_CATEGORY_ERROR:
    case C.CREATE_CATEGORY_ERROR:
    case C.LOAD_CATEGORIES_ERROR: {
      return { ...state, loading: false };
    }
    default:
      return state;
  }
};

export default CategoryReducer;
